<template>
	<div v-if="show">
		<div class="zhe"></div>
		<div class="dialog">
			<h3>IT咨询</h3>
			<p>请填写您的咨询问题，我们将在3~5个工作日内回复您</p>
			<div class="inputbox">
				<img src="../../static/images/home/popup_img.png" alt="">
				<div class="inputbox_right">
					<input type="text" v-model="username" class="right_input" placeholder="您的称呼">
					<input type="number" v-model="mobile" class="right_input" placeholder="您的手机号">
				</div>
			</div>
			<div class="textarea_box">
				<textarea name="" class="textarea" v-model="details" cols="30" rows="10"
					placeholder="请描述您想咨询的问题（如数字化解决方案、商业模式、产品战略、产品规划、问题诊断、风险预估等）~"></textarea>
			</div>
			<div class="button" @click="submit">提交咨询</div>
			<img src="../../static/images/home/guanbi.png" class="close" @click="close">
		</div>

   		<popup class="m_popup" :userBehavior="confirm"></popup>

	</div>
</template>

<script>
	import Popup from '../../components/common/Popup'

	export default {
		props: {
			show: Boolean,
		},
		components: {
			Popup
		},
		data() {
			return {
				username: '',
				mobile: '',
				details: '',
				isPopup: false,
				popupData: {
					type: '手机号码填写不规范，请重新填写！',
					message: '提交成功！'
				}
			}
		},
		watch: {
			show(newV, oldV) {
				if (newV) {
					this.stop();
				} else {
					this.move();
				}
			}

		},
		mounted() {},
		methods: {
			submit() {
				let options = {
					username: this.username,
					mobile: this.mobile,
					details: this.details
				}

				if('7' > options.mobile.length || options.mobile.length > '12' ) {
					confirm(this.popupData.type)
				}else {
					this.$http.post(
						"https://eartisanapplets.wsandos.com/api/index/consulting",
						options,
						(res) => {
							// console.log("res", res)
							if (res.code == 1) {
								this.$emit('close');
								confirm(this.popupData.message)
							}
						}
					);
				}
			},
			close() {
				this.move();
				this.$emit('close');
			},
			//禁止滚动
			stop() {
				var mo = function(e) {
					e.preventDefault();
				};
				document.body.style.overflow = 'hidden';
				document.addEventListener("touchmove", mo, false); //禁止页面滑动
			},
			//取消滑动限制
			move() {
				var mo = function(e) {
					e.preventDefault();
				};
				document.body.style.overflow = ''; //出现滚动条
				document.removeEventListener("touchmove", mo, false);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	input[type="number"] {
		-moz-appearance: textfield;
	}

	.zhe {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		background: #000000;
		opacity: 0.3;
	}

	.dialog {
		position: fixed;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		z-index: 9999;
		width: 920px;
		height: 735px;
		background: #FFFFFF;
		box-shadow: 0px 1px 20px 5px rgba(185, 185, 185, 0.2);
		border-radius: 8px;

		.close {
			position: absolute;
			height: 22px;
			width: 22px;
			right: 32px;
			top: 32px;
		}

		h3 {
			margin-top: 36px;
			font-size: 30px;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #333333;
			text-align: center;
		}

		p {
			font-size: 18px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #666666;
			text-align: center;
			margin-top: 25px;
		}

		.inputbox {
			width: 760px;
			margin: 0 auto;
			margin-top: 31px;
			display: flex;
			justify-content: space-between;

			.inputbox_right {
				display: flex;
				flex-direction: column;
				justify-content: space-around;
			}

			img {
				width: 320px;
				height: 200px;
			}

			.right_input {
				width: 360px;
				height: 54px;
				padding: 0 40px;
				background: #FFFFFF;
				box-shadow: 0px 3px 17px 3px rgba(185, 185, 185, 0.15);
				border-radius: 4px;
			}
		}

		.textarea_box {
			margin: 0 auto;
			margin-top: 5px;
			width: 760px;
			height: 200px;

			.textarea {
				display: block;
				width: 760px;
				height: 200px;
				background: #FFFFFF;
				box-shadow: 0px 3px 17px 3px rgba(185, 185, 185, 0.15);
				border-radius: 4px;
				resize: none;
				padding: 19px 40px;
			}
		}

		.button {
			margin: 0 auto;
			margin-top: 50px;
			width: 200px;
			height: 54px;
			line-height: 54px;
			text-align: center;
			background: #FFC000;
			box-shadow: 0px 5px 20px 5px rgba(185, 185, 185, 0.2);
			border-radius: 4px;
			font-size: 16px;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #333333;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/pc/homepopup.vue